// Supports weights 100-900
import '@fontsource-variable/noto-sans-jp';